import { useState } from 'react';
import type { Nullish } from '@witmetrics/utils';
import type { NonNullableNumberHook, NullableNumberHook } from './types';

export type { NullableNumberHook, NonNullableNumberHook };

export function useNumber(initial: number): NonNullableNumberHook;
export function useNumber(
  initial: number,
  nullable: false
): NonNullableNumberHook;
export function useNumber(initial: null): NullableNumberHook;
export function useNumber(
  initial: number | Nullish,
  nullable: true
): NullableNumberHook;
export function useNumber(
  initial: number | Nullish,
  nullable?: boolean
): NullableNumberHook | NonNullableNumberHook {
  if (initial === null && nullable !== undefined && !nullable) {
    throw new Error('useNumber: non-nullable mode requires an initial number');
  }
  const [value, setValue] = useState<number | null>(initial ?? null);
  // Default now is non-nullable (nullable = false).
  const clear = () => setValue(nullable ? null : (initial ?? null));
  const hook: NullableNumberHook = [value, setValue, clear];
  return hook;
}
